import { MenuWithoutSlug } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <MenuWithoutSlug />;
}
